module.exports = __webpack_public_path__ + "img/2.1b6f0a2f.svg";